import { useState, useEffect } from 'react';
import {
  Container,
  Paper,
  Button,
  Box,
  Typography,
  CircularProgress,
  Grid,
  ThemeProvider,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import NavBar from '../../layout/NavBar';
import { FeedbackApi } from '../../../services/api';
import { darkTheme } from '../../../theme/darkTheme';
import { useNavigate } from 'react-router-dom';
import Notification from '../../util/notifications/Notification';
import NavBarBot from '../../layout/NavBarBot';
import FeedbackCard from './components/feedbackuebersicht/FeedbackCard';
import FeedbackFilterButtons from './components/feedbackuebersicht/FeedbackFilterButtons';

function FeedbackUebersicht() {
  const navigate = useNavigate();
  const [feedback, setFeedback] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState({ type: "", text: "" });
  const [filter, setFilter] = useState('alle');
  const [, setShowNotification] = useState(false);

  useEffect(() => {
    loadFeedback();
  }, []);

  const loadFeedback = async () => {
    try {
      const response = await FeedbackApi.getAllFeedback();
      setFeedback(response.data);
      setLoading(false);
    } catch (err) {
      console.error('Fehler beim Laden des Feedbacks:', err);
      setMessage({ type: "error", text: 'Feedback konnte nicht geladen werden' });
      setLoading(false);
    }
  };

  const handleStatusChange = async (id, newStatus) => {
    try {
      await FeedbackApi.updateFeedbackStatus(id, newStatus);
      setMessage({ type: "success", text: '404' });
      loadFeedback();
    } catch (error) {
      console.error('Fehler beim Aktualisieren des Status:', error);
      setMessage({ type: "error", text: 'Status konnte nicht aktualisiert werden' });
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Wirklich löschen?')) return;

    try {
      await FeedbackApi.deleteFeedback(id);
      setMessage({ type: "success", text: 'Feedback gelöscht' });

      loadFeedback();
    } catch (error) {
      console.error('Fehler beim Löschen:', error);
      setMessage({ type: "error", text: 'Feedback konnte nicht gelöscht werden' });
    }
  };

  const filteredFeedback = feedback.filter((item) => {
    if (filter === 'alle') return true;
    return item.typ === filter;
  });

  return (
    <>
      <ThemeProvider theme={darkTheme}>
        <Box sx={{ bgcolor: 'background.default', minHeight: '100vh', pb: 4 }}>
          <NavBar />

          <Container maxWidth="lg" sx={{ pt: { xs: 2, md: 4 } }}>
            {/* Header */}
            <Box sx={{ mb: 4 }}>
              <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={2} mb={3}>
                <Typography variant="h4" sx={{ fontWeight: 600, color: 'text.primary' }}>
                  Feedback-Übersicht
                </Typography>
              </Box>
            </Box>

            {message.status === "error" || message.status === "success" && (
              <Notification
                type={message.type}
                message={message.text}
                onClose={() => {
                  setShowNotification(true);
                  setMessage({ type: "", text: "" });
                }}
              />
            )}

            {/* Loading */}
            {loading ? (
              <CircularProgress sx={{ position: "absolute", top: "45%", left: "45%", display: 'block', mx: 'auto', mb: 2 }} />
            ) : (
              <>
                {/* Filter Buttons */}
                <FeedbackFilterButtons filter={filter} onFilter={setFilter} feedback={feedback} />

                {/* Feedback List */}
                {filteredFeedback.length > 0 ? (
                  <Grid container spacing={2}>
                    {filteredFeedback.map((item) => (
                      <Grid key={item.id} size={{ xs: 12 }}>
                        <FeedbackCard
                          item={item}
                          onStatusChange={handleStatusChange}
                          onDelete={handleDelete}
                        />
                      </Grid>
                    ))}
                  </Grid>
                ) : (
                  <Paper sx={{ p: 4, textAlign: 'center', bgcolor: 'background.paper' }}>
                    <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
                      Kein Feedback gefunden
                    </Typography>
                    <Button variant="contained" startIcon={<AddIcon />} onClick={() => navigate('/feedback')}>
                      Erstes Feedback erstellen
                    </Button>
                  </Paper>
                )}
              </>
            )}
          </Container>
        </Box>
      </ThemeProvider>
      <NavBarBot />
    </>
  );
}

export default FeedbackUebersicht;
